var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90744 18.4591C3.90744 17.6019 4.58691 16.908 5.42626 16.908C6.25561 16.908 6.93508 17.6019 6.93508 18.4591C6.93508 19.3061 6.25561 20 5.42626 20C4.58691 20 3.90744 19.3061 3.90744 18.4591ZM15.1487 18.4591C15.1487 17.6019 15.8282 16.908 16.6675 16.908C17.4969 16.908 18.1763 17.6019 18.1763 18.4591C18.1763 19.3061 17.4969 20 16.6675 20C15.8282 20 15.1487 19.3061 15.1487 18.4591Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5855 4.61183C19.1858 4.14242 18.7861 3.92812 18.1766 3.92812H4.68209C4.36234 3.92812 4.10254 3.68321 4.07257 3.35564L3.88272 1.06979C3.85274 0.722829 3.60293 0.438118 3.2632 0.37587L0.880056 0.00850099C0.470376 -0.0527271 0.0806793 0.222799 0.0107338 0.641191C-0.0592117 1.04938 0.22057 1.44736 0.620259 1.51879L2.12908 1.78412L3.04837 12.9082C3.15828 14.2542 4.25742 15.2951 5.58639 15.2951H16.4879C17.7569 15.2951 18.8361 14.3471 19.0159 13.0603L19.9652 6.36602C20.0551 5.75476 19.9852 5.08125 19.5855 4.61183Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8891 9.23352H12.1213C11.7016 9.23352 11.3719 8.88656 11.3719 8.46817C11.3719 8.03957 11.7016 7.70282 12.1213 7.70282H14.8891C15.3088 7.70282 15.6386 8.03957 15.6386 8.46817C15.6386 8.88656 15.3088 9.23352 14.8891 9.23352Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartNew);
export default __webpack_public_path__ + "static/media/cart_new.6ef97af1e656c181790ed63e8588ae2b.svg";
export { ForwardRef as ReactComponent };